import { motion } from 'motion/react'
import styled from 'styled-components'

export const FadeContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: inherit;
`
